<script>
    import TableData from './TableData.svelte';
    import Link from '../../../Navigation/Link/v1/Link.svelte';

    /** @type {string} */
    export let href;
    /** @type {string} */
    export let text;
    /** @type {string} */
    export let rel = '';
    /** @type {string} */
    export let target = '_self';
    /** @type {boolean} */
    export let downloadable = false;
    /** @type {string} */
    export let fileName = null;
    /** @type {string} */
    export let ping = undefined;
    /** @type {string} */
    export let description = '';
    /** @type {string} */
    export let icon = '';
    /** @type {string} */
    export let block = '';
</script>

<TableData {icon} {block}>
    <div class="prom-table-cell__link-container">
        <Link {href} {text} {description} {rel} {target} {downloadable} {fileName} {ping} on:click />
    </div>
</TableData>
